import CsvModel from './globals/CsvModel';

export default class StandsCsvModel extends CsvModel {
  static get path() {
    return '/backend/stands.csv';
  }
}
